export default __webpack_public_path__ + "static/media/settings.40ac5334.svg";